import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/AILabel.svg';

export const IconAILabel = createIconComponent(Icon);
